import React, { PropsWithChildren } from 'react'
import cx from 'classnames'

import styles from './styles.module.scss'

type Props = {
	theme?: 'blue' | 'wheat' | 'green' | 'main'
	use?: 'normal' | 'small'
	className?: string
	width?: string
}

export const View = ({
	theme,
	use = 'normal',
	className,
	width,
	children,
}: PropsWithChildren<Props>) => {
	return (
		<div
			data-test-id='badge'
			className={cx(className, styles.badge, {
				[styles[theme!]]: !!theme,
				[styles['normal']]: use === 'normal',
				[styles['small']]: use === 'small',
			})}
			style={{ width }}
		>
			{children}
		</div>
	)
}
